<div mat-dialog-title class="d-flex flex-column">
  <div class="me-5">{{terminIn.predmetNazov}}</div>
  <div>{{terminIn.datumSk}}</div>
</div>
<hr/>
<mat-dialog-content>
  <mat-spinner *ngIf="loading"></mat-spinner>
  <div class="mb-3"><span i18n>Zoznam prihlásených</span></div>
  <ul *ngIf="studenti.length > 0">
    <li *ngFor="let s of studenti">
      <div *ngIf="s.plneMeno!=='unknown'">{{s.plneMeno}}</div>
      <div *ngIf="s.plneMeno=='unknown'"><span i18n>unknown</span></div>
    </li>
  </ul>
  <ul *ngIf="studenti.length == 0">
    <li><span i18n>Na termíne nie sú prihlásení študenti.</span></li>
  </ul>
</mat-dialog-content>
<hr/>
<mat-dialog-actions class="d-flex justify-content-end">
  <button mat-button mat-dialog-close><span i18n>Close</span></button>
</mat-dialog-actions>
